'use client';

import { useRoadmapClassification } from '@/domain/roadmap/hooks';
import { type RoadmapClassification, type RoadMapUpdate } from '@/domain/roadmap/types';
import { FormControl } from '@andritzot/metris-web-ui/inputs/form-control';
import { InputLabel } from '@andritzot/metris-web-ui/inputs/input-label';
import { Select } from '@andritzot/metris-web-ui/inputs/select';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { MenuItem } from '@andritzot/metris-web-ui/navigation/menu/menu-item';
import { type Control, Controller } from 'react-hook-form';

import { FieldActionsWrapper } from './shared/FieldActionsWrapper';

interface ClassificationFieldProps {
  viewOnly: boolean;
  control: Control<RoadMapUpdate, unknown>;
}

export function ClassificationField({ viewOnly, control }: Readonly<ClassificationFieldProps>) {
  const { data: classifications = [] } = useRoadmapClassification();

  return (
    <Box sx={{ py: 0.75, width: '100%' }}>
      <Controller
        name="classification"
        control={control}
        render={({ field: { value, onChange } }) => (
          <FieldActionsWrapper>
            <FormControl fullWidth size="small" disabled={viewOnly}>
              <InputLabel id="classification-label">Classification</InputLabel>
              <Select
                labelId="classification-label"
                label="Classification"
                value={value ?? ''}
                onChange={(e) => onChange(Number(e.target.value))}
              >
                {classifications.map((opt: RoadmapClassification) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </FieldActionsWrapper>
        )}
      />
    </Box>
  );
}
